import { Divider, Grid, Paper, Skeleton, Stack, Typography } from "@mui/material"
import React from "react"
import { AdjustmentCancel } from "../../Objects/AdjustmentCancel"

export interface AdjustmentCancelListProps {
    adj_cancel_list?: AdjustmentCancel[]
}
const AdjustmentCancelList: React.FC<AdjustmentCancelListProps> = ({
    adj_cancel_list
}) => {
    return (
        <Paper
            variant="outlined"
            sx={{
                p: 2
            }}
        >
            <Stack
                spacing={1}
            >
                {adj_cancel_list ? adj_cancel_list.map((adjustment, index) => (
                    <Grid container key={index}
                        sx={{
                            px: 2
                        }}
                    >
                        <Grid item xs={10} sm={5}>
                            <Typography textAlign="left">{adjustment.item}</Typography>
                        </Grid>
                        <Grid item xs={2} sm={2}>
                            <Typography textAlign="right">×{adjustment.number}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={5}>
                            <Typography textAlign="right">{adjustment.charge.toLocaleString()}円</Typography>
                        </Grid>
                    </Grid>
                )) : (
                    <Skeleton variant="rectangular" height={50} />
                )}
                {adj_cancel_list && adj_cancel_list.length > 0 &&
                    <Divider />
                }
                <Grid container
                    sx={{
                        px: 2
                    }}
                >
                    <Grid item xs={10} sm={5}>
                        <Typography textAlign="left" color="primary" fontWeight="bold">支払済みキャンセル代合計</Typography>
                    </Grid>
                    <Grid item xs={2} sm={2}>
                        <Typography textAlign="right">×{adj_cancel_list ? adj_cancel_list.reduce<number>((prev, adjustment) => prev + adjustment.number, 0) : "-"}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={5}>
                        <Typography textAlign="right">{adj_cancel_list ? adj_cancel_list.reduce<number>((prev, adjustment) => prev + adjustment.charge, 0).toLocaleString() : "-"}円</Typography>
                    </Grid>
                </Grid>
            </Stack>
        </Paper>
    )
}

export default AdjustmentCancelList